export default {
  title: 'Arquivos anexos'
}